import { render, staticRenderFns } from "./SectionFooter.vue?vue&type=template&id=8db6f5ac&"
import script from "./SectionFooter.vue?vue&type=script&lang=ts&"
export * from "./SectionFooter.vue?vue&type=script&lang=ts&"
import style0 from "./SectionFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports